import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const wheelEfficiencyLabelIsEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('showTyreLabel'),
)

export default wheelEfficiencyLabelIsEnabledSelector
